import * as actionTypes from './actionTypes'

var nextRequestId = 0
function generateRequestId () {
  return nextRequestId++
}

/**
 * Creates a request action.
 * @param {Object} options
 * @param {string} options.url The url for the request
 * @param {Object} [options.queryParams] Query parameters to be added to the url string
 * @param {string} [options.responseType] The data type assumed to be received in the response body
 * @param {Blob|BufferSource|FormData|UrlSearchParams|string} [options.body] The request body
 */
export function request (options) {
  return {
    type: actionTypes.REQUEST,
    payload: options,
    meta: {
      requestId: generateRequestId()
    }
  }
}

/**
 * Creates a response action.
 */
export function response (requestId, result, error = false) {
  return {
    type: actionTypes.RESPONSE,
    payload: result,
    error,
    meta: {
      requestId: requestId
    }
  }
}

/**
 * Action to signify a REST request has encountered an authorization error.
 * @param  {BasicError} error
 * @return {Action}
 */
export function authorizationError (error) {
  return {
    error: true,
    type: actionTypes.AUTHORIZATION_ERROR,
    payload: error
  }
}
